import { useCallback, useState } from 'react';

import useInputChanges from './functions/useInputChanges';
import usePermissions from './functions/usePermissions';
import useLoadForm from './functions/useLoadForm';
import useFormSubmit from './functions/useFormSubmit';

export default function useInternalUserForm() {
  const [isLoadLoading, setIsLoadLoading] = useState(false);

  const {
    permissionsOptions,
    selectedPermissions,
    pageBeingSettedPermissions,
    permissionsOfPageModalShow,
    selectedActions,
    handleActionSelect,
    handleOpenPageBeingSettedPermissionsModal,
    handlePermissionsChange,
    setPermissionsOfPageModalShow,
    getPermissionsOptions,
    defaultPermissions,
    adminPermissions,
    setSelectedPermissions,
  } = usePermissions({ setIsLoadLoading });

  const {
    name,
    cpf,
    email,
    type,
    getErrorMessageByFieldName,
    errors,
    handleNameChange,
    handleCpfChange,
    handleEmailChange,
    handleTypeChange,
    setName,
    setCpf,
    setEmail,
    setType,
  } = useInputChanges({
    selectedPermissions,
    adminPermissions,
    setSelectedPermissions,
    defaultPermissions,
  });

  const { typeOptions } = useLoadForm({
    setIsLoadLoading,
    setCpf,
    setEmail,
    setName,
    setType,
    setSelectedPermissions,
    adminPermissions,
    defaultPermissions,
    getPermissionsOptions,
  });

  const resetFields = useCallback(() => {
    setName('');
    setCpf('');
    setEmail('');
    setType({ value: 2, label: 'Padrão' });
    setSelectedPermissions(permissionsOptions);
  }, [permissionsOptions, setCpf, setEmail, setName, setSelectedPermissions, setType]);

  const {
    isSubmitting,
    createUser,
    editUser,
  } = useFormSubmit({
    type,
    name,
    cpf,
    email,
    selectedPermissions,
    resetFields,
  });

  const isFormValid = errors.length === 0 && !!name && !!cpf && !!email;

  const isLoading = isLoadLoading || isSubmitting;

  return {
    isLoadLoading,
    name,
    cpf,
    email,
    type,
    typeOptions,
    permissionsOptions,
    selectedPermissions,
    pageBeingSettedPermissions,
    permissionsOfPageModalShow,
    selectedActions,
    getErrorMessageByFieldName,
    errors,
    handleNameChange,
    handleCpfChange,
    handleEmailChange,
    handleTypeChange,
    handleActionSelect,
    handleOpenPageBeingSettedPermissionsModal,
    handlePermissionsChange,
    setPermissionsOfPageModalShow,
    createUser,
    editUser,
    isLoading,
    isFormValid,
  };
}
